import React from 'react';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import fr_CA from './i18n/fr_CA';
import en_CA from './i18n/en_CA';

i18next.addResourceBundle('fr-CA', 'dApp', fr_CA);
i18next.addResourceBundle('en-CA', 'dApp', en_CA);

export const DivisionsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	name: 'Divisions',
	auth    : "division_management",
	routes: [
		
		{
			path: '/app/divisions/item/:itemId/:itemSlug?',
			component: React.lazy(() => import('./views/Division'))
		},
		{
			path: '/app/divisions/list',
			component: React.lazy(() => import('./views/List'))
		},
		{
			path: '/app/divisions',
			component: () => <Redirect to="/app/divisions/list" />
		}
	]
};
